import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/usuario`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms = {}) {

            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        assinatura(params) {

            return repository.post(`${baseUrl}/assinatura`, params)
        },
        loadAssinatura(id) {

            return repository.get(`${baseUrl}/${id}/load-assinatura`)
        },
        destroyAssinatura(id) {

            return repository.delete(`${baseUrl}/${id}/destroy-assinatura`)
        },
        downloadAssinatura(id) {

            return repository.get(`${baseUrl}/${id}/download-assinatura`, { responseType: "arraybuffer" })
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        gerarSenha(id) {

            return repository.put(`${baseUrl}/${id}/gerar-senha`)
        },
        bloquear(id) {

            return repository.put(`${baseUrl}/${id}/bloquear`)
        },
        desbloquear(id) {

            return repository.put(`${baseUrl}/${id}/desbloquear`)
        },
        lotacoes(id) {

            return repository.get(`${baseUrl}/${id}/lotacoes`)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {

            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getCentrosCusto(queryParms) {

            return repository.get(`${baseUrl}/centros-custo?${urlUtil.serialize(queryParms)}`)
        },
    }
}